module.exports = __WEBPACK_EXTERNAL_MODULE__788__;